import superagent from 'superagent'
import q from 'q'
import { idAuthenticator } from '../plugins/auth'
import Environment from '../plugins/environment'
import metrics from '../services/metrics'
import { ID } from '../enums/clients'

const REQUEST_TIMEOUT = 60000
const REQUEST_ACCEPT_TYPE = 'application/json'
const CLIENT_ID = {client: 'contentportal.smarttech.com'}
const ID_ENDPOINT = '/api/me/account/data'

/**
 * stores the provided key value pair
 * use {'shareComplete': true} when user has completed their first upload
 * @param keyValue - {key: value}
 * @returns {Function}
 */
let storeData = (keyValue) => {
  let deferred = q.defer()
  let request = superagent('PUT', Environment.serviceUrlFor(ID) + ID_ENDPOINT)
  request.set('Authorization', 'Bearer ' + idAuthenticator.getAccessToken())
  request.timeout(REQUEST_TIMEOUT)
  request.accept(REQUEST_ACCEPT_TYPE)
  request.query(CLIENT_ID)
  request.send(keyValue)
  request.end(function (error, response) {
    if (error) {
      deferred.reject(error)
      metrics
        .sendMetric(metrics.CATEGORIES.THIRD_PARTY_CALLS, metrics.CP_TAGS.SAVE_ID_STORE_ERROR, 1, metrics.TYPE.FAILURE_COUNTER, error)
    } else {
      deferred.resolve(response)
    }
  })
  return deferred.promise
}
/**
 * fetches the stored key value pairs
 * @returns {Function}
 */
let fetchData = () => {
  let deferred = q.defer()
  let request = superagent('GET', Environment.serviceUrlFor(ID) + ID_ENDPOINT)
  request.set('Authorization', 'Bearer ' + idAuthenticator.getAccessToken())
  request.timeout(REQUEST_TIMEOUT)
  request.accept(REQUEST_ACCEPT_TYPE)
  request.query(CLIENT_ID)
  request.end(function (error, response) {
    if (error) {
      deferred.reject(error)
      metrics
        .sendMetric(metrics.CATEGORIES.THIRD_PARTY_CALLS, metrics.CP_TAGS.FETCH_ID_STORE_ERROR, 1, metrics.TYPE.FAILURE_COUNTER, error)
    } else {
      deferred.resolve(response)
    }
  })
  return deferred.promise
}

export default {
  storeData,
  fetchData
}
